"use client";

import { Component, ReactNode } from "react";

class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
	constructor(props: any) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: any, errorInfo: any) {
		console.error("ErrorBoundary caught an error", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="error-bound flex flex-h-center">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200" fill="none">
						<g stroke="#ff6b6b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="150" cy="100" r="40" fill="none" />
							<line x1="140" y1="90" x2="160" y2="110" />
							<line x1="160" y1="90" x2="140" y2="110" />
						</g>
						<text x="50%" y="170" dominant-baseline="middle" text-anchor="middle" font-family="Arial, sans-serif" font-size="16" fill="#333">
							Oh no! Da hat etwas nicht funktioniert.
						</text>
						<text x="50%" y="190" dominant-baseline="middle" text-anchor="middle" font-family="Arial, sans-serif" font-size="14" fill="#666">
							Bitte lade noch einmal neu.
						</text>
					</svg>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
